(function () {
  var savedReviews = null;
  document.addEventListener(
    'click',
    function (e) {
      var link = e.target.closest('.stamped-pagination a[data-page]');
      if (!link) return;
      var container = document.getElementById('stamped-reviews-tab');
      if (!container) return;
      var reviews = container.querySelectorAll('.stamped-review');
      savedReviews = Array.from(reviews).map((r) => r.cloneNode(true));
    },
    true,
  );
  document.addEventListener('stamped:reviews:loaded', function () {
    if (!savedReviews || !savedReviews.length) return;
    var container = document.getElementById('stamped-reviews-tab');
    if (!container) return;
    var firstNew = container.querySelector('.stamped-review');
    if (!firstNew) return;
    savedReviews.forEach((r) => firstNew.parentNode.insertBefore(r, firstNew));
    savedReviews = null;
  });
})();
